module.exports = __webpack_public_path__ + "static/img/putao.a9eb168e.png";